/* eslint-disable import/order */
import axios from 'axios';
import { generateHeader } from 'common/utils/APIUtils';
import { useQuery } from 'react-query';
import { keys } from '../keys';
// import Config from 'Config';

// const baseUrl = `${Config.apiUrl}/classes/Procedure`;

const listAllDeviceProcedures = deviceId => {
    const headers = generateHeader();

    return axios.get(`/devices/${deviceId}/procedures`, { headers });
};

export const useListDeviceProcedures = (deviceId, enableAPI) => {
    const result = useQuery(['device', deviceId, ...keys.procedure.list(), enableAPI], () => listAllDeviceProcedures(deviceId), {
        enabled: enableAPI,
        refetchOnMount: true,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
    });

    const procedures = result && result.data ? result.data.data : [];

    return {
        procedures,
        isLoading: result.isLoading,
        isFetching: result.isFetching,
    };
};
